/* @generated */
// prettier-ignore
if (Intl.NumberFormat && typeof Intl.NumberFormat.__addLocaleData === 'function') {
  Intl.NumberFormat.__addLocaleData({
    "data": {
      "currencies": {
        "AED": {
          "displayName": {
            "other": "Laaraw Immaara Margantey Dirham"
          },
          "narrow": "AED",
          "symbol": "AED"
        },
        "AFN": {
          "displayName": {},
          "narrow": "؋",
          "symbol": "AFN"
        },
        "AMD": {
          "displayName": {},
          "narrow": "֏",
          "symbol": "AMD"
        },
        "AOA": {
          "displayName": {
            "other": "Angoola Kwanza"
          },
          "narrow": "Kz",
          "symbol": "AOA"
        },
        "ARS": {
          "displayName": {},
          "narrow": "$",
          "symbol": "ARS"
        },
        "AUD": {
          "displayName": {
            "other": "Ostraali Dollar"
          },
          "narrow": "$",
          "symbol": "A$"
        },
        "AZN": {
          "displayName": {},
          "narrow": "₼",
          "symbol": "AZN"
        },
        "BAM": {
          "displayName": {},
          "narrow": "KM",
          "symbol": "BAM"
        },
        "BBD": {
          "displayName": {},
          "narrow": "$",
          "symbol": "BBD"
        },
        "BDT": {
          "displayName": {},
          "narrow": "৳",
          "symbol": "BDT"
        },
        "BHD": {
          "displayName": {
            "other": "Bahareen Dinar"
          },
          "narrow": "BHD",
          "symbol": "BHD"
        },
        "BIF": {
          "displayName": {
            "other": "Burundi Fraŋ"
          },
          "narrow": "BIF",
          "symbol": "BIF"
        },
        "BMD": {
          "displayName": {},
          "narrow": "$",
          "symbol": "BMD"
        },
        "BND": {
          "displayName": {},
          "narrow": "$",
          "symbol": "BND"
        },
        "BOB": {
          "displayName": {},
          "narrow": "Bs",
          "symbol": "BOB"
        },
        "BRL": {
          "displayName": {},
          "narrow": "R$",
          "symbol": "R$"
        },
        "BSD": {
          "displayName": {},
          "narrow": "$",
          "symbol": "BSD"
        },
        "BWP": {
          "displayName": {
            "other": "Botswaana Pund"
          },
          "narrow": "P",
          "symbol": "BWP"
        },
        "BZD": {
          "displayName": {},
          "narrow": "$",
          "symbol": "BZD"
        },
        "CAD": {
          "displayName": {
            "other": "Kanaada Dollar"
          },
          "narrow": "$",
          "symbol": "CA$"
        },
        "CDF": {
          "displayName": {
            "other": "Kongo Fraŋ"
          },
          "narrow": "CDF",
          "symbol": "CDF"
        },
        "CHF": {
          "displayName": {
            "other": "Swisu Fraŋ"
          },
          "narrow": "CHF",
          "symbol": "CHF"
        },
        "CLP": {
          "displayName": {},
          "narrow": "$",
          "symbol": "CLP"
        },
        "CNY": {
          "displayName": {
            "other": "Sinwa Yuan Renminbi"
          },
          "narrow": "¥",
          "symbol": "CN¥"
        },
        "COP": {
          "displayName": {},
          "narrow": "$",
          "symbol": "COP"
        },
        "CRC": {
          "displayName": {},
          "narrow": "₡",
          "symbol": "CRC"
        },
        "CUC": {
          "displayName": {},
          "narrow": "$",
          "symbol": "CUC"
        },
        "CUP": {
          "displayName": {},
          "narrow": "$",
          "symbol": "CUP"
        },
        "CVE": {
          "displayName": {
            "other": "Kapuver Escudo"
          },
          "narrow": "CVE",
          "symbol": "CVE"
        },
        "CZK": {
          "displayName": {},
          "narrow": "Kč",
          "symbol": "CZK"
        },
        "DJF": {
          "displayName": {
            "other": "Jibuuti Fraŋ"
          },
          "narrow": "DJF",
          "symbol": "DJF"
        },
        "DKK": {
          "displayName": {},
          "narrow": "kr",
          "symbol": "DKK"
        },
        "DOP": {
          "displayName": {},
          "narrow": "$",
          "symbol": "DOP"
        },
        "DZD": {
          "displayName": {
            "other": "Alžeeri Dinar"
          },
          "narrow": "DZD",
          "symbol": "DZD"
        },
        "EGP": {
          "displayName": {
            "other": "Misra Pund"
          },
          "narrow": "E£",
          "symbol": "EGP"
        },
        "ERN": {
          "displayName": {
            "other": "Eritree Nafka"
          },
          "narrow": "ERN",
          "symbol": "ERN"
        },
        "ESP": {
          "displayName": {},
          "narrow": "₧",
          "symbol": "ESP"
        },
        "ETB": {
          "displayName": {
            "other": "Ecioopi Birr"
          },
          "narrow": "ETB",
          "symbol": "ETB"
        },
        "EUR": {
          "displayName": {
            "other": "Eero"
          },
          "narrow": "€",
          "symbol": "€"
        },
        "FJD": {
          "displayName": {},
          "narrow": "$",
          "symbol": "FJD"
        },
        "FKP": {
          "displayName": {},
          "narrow": "£",
          "symbol": "FKP"
        },
        "GBP": {
          "displayName": {
            "other": "Britin Pund"
          },
          "narrow": "£",
          "symbol": "£"
        },
        "GEL": {
          "displayName": {},
          "narrow": "₾",
          "symbol": "GEL"
        },
        "GHC": {
          "displayName": {
            "other": "Gaana Šiidi"
          },
          "narrow": "GHC",
          "symbol": "GHC"
        },
        "GHS": {
          "displayName": {},
          "narrow": "GH₵",
          "symbol": "GHS"
        },
        "GIP": {
          "displayName": {},
          "narrow": "£",
          "symbol": "GIP"
        },
        "GMD": {
          "displayName": {
            "other": "Gambi Dalasi"
          },
          "narrow": "GMD",
          "symbol": "GMD"
        },
        "GNF": {
          "displayName": {},
          "narrow": "FG",
          "symbol": "GNF"
        },
        "GNS": {
          "displayName": {
            "other": "Ginee Fraŋ"
          },
          "narrow": "GNS",
          "symbol": "GNS"
        },
        "GTQ": {
          "displayName": {},
          "narrow": "Q",
          "symbol": "GTQ"
        },
        "GYD": {
          "displayName": {},
          "narrow": "$",
          "symbol": "GYD"
        },
        "HKD": {
          "displayName": {},
          "narrow": "$",
          "symbol": "HK$"
        },
        "HNL": {
          "displayName": {},
          "narrow": "L",
          "symbol": "HNL"
        },
        "HRK": {
          "displayName": {},
          "narrow": "kn",
          "symbol": "HRK"
        },
        "HUF": {
          "displayName": {},
          "narrow": "Ft",
          "symbol": "HUF"
        },
        "IDR": {
          "displayName": {},
          "narrow": "Rp",
          "symbol": "IDR"
        },
        "ILS": {
          "displayName": {},
          "narrow": "₪",
          "symbol": "₪"
        },
        "INR": {
          "displayName": {
            "other": "Indu Rupii"
          },
          "narrow": "₹",
          "symbol": "₹"
        },
        "ISK": {
          "displayName": {},
          "narrow": "kr",
          "symbol": "ISK"
        },
        "JMD": {
          "displayName": {},
          "narrow": "$",
          "symbol": "JMD"
        },
        "JPY": {
          "displayName": {
            "other": "Jaapoŋ Yen"
          },
          "narrow": "¥",
          "symbol": "JP¥"
        },
        "KES": {
          "displayName": {
            "other": "Keeniya Šiiliŋ"
          },
          "narrow": "KES",
          "symbol": "KES"
        },
        "KHR": {
          "displayName": {},
          "narrow": "៛",
          "symbol": "KHR"
        },
        "KMF": {
          "displayName": {
            "other": "Komoor Fraŋ"
          },
          "narrow": "CF",
          "symbol": "KMF"
        },
        "KPW": {
          "displayName": {},
          "narrow": "₩",
          "symbol": "KPW"
        },
        "KRW": {
          "displayName": {},
          "narrow": "₩",
          "symbol": "₩"
        },
        "KYD": {
          "displayName": {},
          "narrow": "$",
          "symbol": "KYD"
        },
        "KZT": {
          "displayName": {},
          "narrow": "₸",
          "symbol": "KZT"
        },
        "LAK": {
          "displayName": {},
          "narrow": "₭",
          "symbol": "LAK"
        },
        "LBP": {
          "displayName": {},
          "narrow": "L£",
          "symbol": "LBP"
        },
        "LKR": {
          "displayName": {},
          "narrow": "Rs",
          "symbol": "LKR"
        },
        "LRD": {
          "displayName": {
            "other": "Liberia Dollar"
          },
          "narrow": "$",
          "symbol": "LRD"
        },
        "LSL": {
          "displayName": {
            "other": "Leezoto Loti"
          },
          "narrow": "LSL",
          "symbol": "LSL"
        },
        "LTL": {
          "displayName": {},
          "narrow": "Lt",
          "symbol": "LTL"
        },
        "LVL": {
          "displayName": {},
          "narrow": "Ls",
          "symbol": "LVL"
        },
        "LYD": {
          "displayName": {
            "other": "Liibi Dinar"
          },
          "narrow": "LYD",
          "symbol": "LYD"
        },
        "MAD": {
          "displayName": {
            "other": "Maarok Dirham"
          },
          "narrow": "MAD",
          "symbol": "MAD"
        },
        "MGA": {
          "displayName": {
            "other": "Malgaaši Fraŋ"
          },
          "narrow": "Ar",
          "symbol": "MGA"
        },
        "MMK": {
          "displayName": {},
          "narrow": "K",
          "symbol": "MMK"
        },
        "MNT": {
          "displayName": {},
          "narrow": "₮",
          "symbol": "MNT"
        },
        "MRO": {
          "displayName": {
            "other": "Mooritaani Ugiya (1973–2017)"
          },
          "narrow": "MRO",
          "symbol": "MRO"
        },
        "MRU": {
          "displayName": {
            "other": "Mooritaani Ugiya"
          },
          "narrow": "MRU",
          "symbol": "MRU"
        },
        "MUR": {
          "displayName": {
            "other": "Mooris Rupii"
          },
          "narrow": "Rs",
          "symbol": "MUR"
        },
        "MWK": {
          "displayName": {
            "other": "Malaawi Kwaca"
          },
          "narrow": "MWK",
          "symbol": "MWK"
        },
        "MXN": {
          "displayName": {},
          "narrow": "$",
          "symbol": "MX$"
        },
        "MYR": {
          "displayName": {},
          "narrow": "RM",
          "symbol": "MYR"
        },
        "MZM": {
          "displayName": {
            "other": "Mozambik Metikal"
          },
          "narrow": "MZM",
          "symbol": "MZM"
        },
        "NAD": {
          "displayName": {
            "other": "Naamibi Dollar"
          },
          "narrow": "$",
          "symbol": "NAD"
        },
        "NGN": {
          "displayName": {
            "other": "Naajiriya Neera"
          },
          "narrow": "₦",
          "symbol": "NGN"
        },
        "NIO": {
          "displayName": {},
          "narrow": "C$",
          "symbol": "NIO"
        },
        "NOK": {
          "displayName": {},
          "narrow": "kr",
          "symbol": "NOK"
        },
        "NPR": {
          "displayName": {},
          "narrow": "Rs",
          "symbol": "NPR"
        },
        "NZD": {
          "displayName": {},
          "narrow": "$",
          "symbol": "NZ$"
        },
        "PHP": {
          "displayName": {},
          "narrow": "₱",
          "symbol": "₱"
        },
        "PKR": {
          "displayName": {},
          "narrow": "Rs",
          "symbol": "PKR"
        },
        "PLN": {
          "displayName": {},
          "narrow": "zł",
          "symbol": "PLN"
        },
        "PYG": {
          "displayName": {},
          "narrow": "₲",
          "symbol": "PYG"
        },
        "RON": {
          "displayName": {},
          "narrow": "lei",
          "symbol": "RON"
        },
        "RUB": {
          "displayName": {},
          "narrow": "₽",
          "symbol": "RUB"
        },
        "RWF": {
          "displayName": {
            "other": "Rwanda Fraŋ"
          },
          "narrow": "RF",
          "symbol": "RWF"
        },
        "SAR": {
          "displayName": {
            "other": "Saudiya Riyal"
          },
          "narrow": "SAR",
          "symbol": "SAR"
        },
        "SBD": {
          "displayName": {},
          "narrow": "$",
          "symbol": "SBD"
        },
        "SCR": {
          "displayName": {
            "other": "Seešel Rupii"
          },
          "narrow": "SCR",
          "symbol": "SCR"
        },
        "SDG": {
          "displayName": {
            "other": "Suudaŋ Dinar"
          },
          "narrow": "SDG",
          "symbol": "SDG"
        },
        "SDP": {
          "displayName": {
            "other": "Suudaŋ Pund"
          },
          "narrow": "SDP",
          "symbol": "SDP"
        },
        "SEK": {
          "displayName": {},
          "narrow": "kr",
          "symbol": "SEK"
        },
        "SGD": {
          "displayName": {},
          "narrow": "$",
          "symbol": "SGD"
        },
        "SHP": {
          "displayName": {
            "other": "Seŋ Helena Fraŋ"
          },
          "narrow": "£",
          "symbol": "SHP"
        },
        "SLL": {
          "displayName": {
            "other": "Leeon"
          },
          "narrow": "SLL",
          "symbol": "SLL"
        },
        "SOS": {
          "displayName": {
            "other": "Somaali Šiiliŋ"
          },
          "narrow": "SOS",
          "symbol": "SOS"
        },
        "SRD": {
          "displayName": {},
          "narrow": "$",
          "symbol": "SRD"
        },
        "SSP": {
          "displayName": {},
          "narrow": "£",
          "symbol": "SSP"
        },
        "STD": {
          "displayName": {
            "other": "Sao Tome nda Prinsipe Dobra (1977–2017)"
          },
          "narrow": "STD",
          "symbol": "STD"
        },
        "STN": {
          "displayName": {
            "other": "Sao Tome nda Prinsipe Dobra"
          },
          "narrow": "Db",
          "symbol": "STN"
        },
        "SYP": {
          "displayName": {},
          "narrow": "£",
          "symbol": "SYP"
        },
        "SZL": {
          "displayName": {
            "other": "Lilangeni"
          },
          "narrow": "SZL",
          "symbol": "SZL"
        },
        "THB": {
          "displayName": {},
          "narrow": "฿",
          "symbol": "THB"
        },
        "TND": {
          "displayName": {
            "other": "Tunizi Dinar"
          },
          "narrow": "TND",
          "symbol": "TND"
        },
        "TOP": {
          "displayName": {},
          "narrow": "T$",
          "symbol": "TOP"
        },
        "TRY": {
          "displayName": {},
          "narrow": "₺",
          "symbol": "TRY"
        },
        "TTD": {
          "displayName": {},
          "narrow": "$",
          "symbol": "TTD"
        },
        "TWD": {
          "displayName": {},
          "narrow": "$",
          "symbol": "NT$"
        },
        "TZS": {
          "displayName": {
            "other": "Tanzaani Šiiliŋ"
          },
          "narrow": "TZS",
          "symbol": "TZS"
        },
        "UAH": {
          "displayName": {},
          "narrow": "₴",
          "symbol": "UAH"
        },
        "UGX": {
          "displayName": {
            "other": "Uganda Šiiliŋ"
          },
          "narrow": "UGX",
          "symbol": "UGX"
        },
        "USD": {
          "displayName": {
            "other": "Ameriki Dollar"
          },
          "narrow": "$",
          "symbol": "US$"
        },
        "UYU": {
          "displayName": {},
          "narrow": "$",
          "symbol": "UYU"
        },
        "VEF": {
          "displayName": {},
          "narrow": "Bs",
          "symbol": "VEF"
        },
        "VND": {
          "displayName": {},
          "narrow": "₫",
          "symbol": "₫"
        },
        "XAF": {
          "displayName": {
            "other": "CFA Fraŋ (BEAC)"
          },
          "narrow": "FCFA",
          "symbol": "FCFA"
        },
        "XCD": {
          "displayName": {},
          "narrow": "$",
          "symbol": "EC$"
        },
        "XOF": {
          "displayName": {
            "other": "CFA Fraŋ (BCEAO)"
          },
          "narrow": "F CFA",
          "symbol": "F CFA"
        },
        "XPF": {
          "displayName": {},
          "narrow": "CFPF",
          "symbol": "CFPF"
        },
        "XXX": {
          "displayName": {},
          "narrow": "¤",
          "symbol": "¤"
        },
        "ZAR": {
          "displayName": {
            "other": "Hawasa Afriki Rand"
          },
          "narrow": "R",
          "symbol": "ZAR"
        },
        "ZMK": {
          "displayName": {
            "other": "Zambi Kwaca (1968–2012)"
          },
          "narrow": "ZMK",
          "symbol": "ZMK"
        },
        "ZMW": {
          "displayName": {
            "other": "Zambi Kwaca"
          },
          "narrow": "ZK",
          "symbol": "ZMW"
        },
        "ZWD": {
          "displayName": {
            "other": "Zimbabwe Dollar"
          },
          "narrow": "ZWD",
          "symbol": "ZWD"
        }
      },
      "nu": ["latn"],
      "numbers": {
        "currency": {
          "latn": {
            "accounting": "#,##0.00¤",
            "currencySpacing": {
              "afterInsertBetween": " ",
              "beforeInsertBetween": " "
            },
            "short": {
              "1000": {
                "other": "¤ 0K"
              },
              "10000": {
                "other": "¤ 00K"
              },
              "100000": {
                "other": "¤ 000K"
              },
              "1000000": {
                "other": "¤ 0M"
              },
              "10000000": {
                "other": "¤ 00M"
              },
              "100000000": {
                "other": "¤ 000M"
              },
              "1000000000": {
                "other": "¤ 0G"
              },
              "10000000000": {
                "other": "¤ 00G"
              },
              "100000000000": {
                "other": "¤ 000G"
              },
              "1000000000000": {
                "other": "¤ 0T"
              },
              "10000000000000": {
                "other": "¤ 00T"
              },
              "100000000000000": {
                "other": "¤ 000T"
              }
            },
            "standard": "#,##0.00¤",
            "unitPattern": "{0} {1}"
          }
        },
        "decimal": {
          "latn": {
            "long": {
              "1000": {
                "other": "0K"
              },
              "10000": {
                "other": "00K"
              },
              "100000": {
                "other": "000K"
              },
              "1000000": {
                "other": "0M"
              },
              "10000000": {
                "other": "00M"
              },
              "100000000": {
                "other": "000M"
              },
              "1000000000": {
                "other": "0G"
              },
              "10000000000": {
                "other": "00G"
              },
              "100000000000": {
                "other": "000G"
              },
              "1000000000000": {
                "other": "0T"
              },
              "10000000000000": {
                "other": "00T"
              },
              "100000000000000": {
                "other": "000T"
              }
            },
            "short": {
              "1000": {
                "other": "0K"
              },
              "10000": {
                "other": "00K"
              },
              "100000": {
                "other": "000K"
              },
              "1000000": {
                "other": "0M"
              },
              "10000000": {
                "other": "00M"
              },
              "100000000": {
                "other": "000M"
              },
              "1000000000": {
                "other": "0G"
              },
              "10000000000": {
                "other": "00G"
              },
              "100000000000": {
                "other": "000G"
              },
              "1000000000000": {
                "other": "0T"
              },
              "10000000000000": {
                "other": "00T"
              },
              "100000000000000": {
                "other": "000T"
              }
            },
            "standard": "#,##0.###"
          }
        },
        "nu": ["latn"],
        "percent": {
          "latn": "#,##0%"
        },
        "symbols": {
          "latn": {
            "approximatelySign": "~",
            "decimal": ".",
            "exponential": "E",
            "group": " ",
            "infinity": "∞",
            "list": ";",
            "minusSign": "-",
            "nan": "NaN",
            "perMille": "‰",
            "percentSign": "%",
            "plusSign": "+",
            "rangeSign": "–",
            "superscriptingExponent": "×",
            "timeSeparator": ":"
          }
        }
      },
      "units": {
        "compound": {
          "per": {
            "long": "{0}/{1}",
            "narrow": "{0}/{1}",
            "short": "{0}/{1}"
          }
        },
        "simple": {
          "acre": {
            "long": {
              "other": "{0} ac"
            },
            "narrow": {
              "other": "{0} ac"
            },
            "perUnit": {},
            "short": {
              "other": "{0} ac"
            }
          },
          "bit": {
            "long": {
              "other": "{0} bit"
            },
            "narrow": {
              "other": "{0} bit"
            },
            "perUnit": {},
            "short": {
              "other": "{0} bit"
            }
          },
          "byte": {
            "long": {
              "other": "{0} byte"
            },
            "narrow": {
              "other": "{0} byte"
            },
            "perUnit": {},
            "short": {
              "other": "{0} byte"
            }
          },
          "celsius": {
            "long": {
              "other": "{0}°C"
            },
            "narrow": {
              "other": "{0}°C"
            },
            "perUnit": {},
            "short": {
              "other": "{0}°C"
            }
          },
          "centimeter": {
            "long": {
              "other": "{0} cm"
            },
            "narrow": {
              "other": "{0} cm"
            },
            "perUnit": {
              "long": "{0}/cm",
              "narrow": "{0}/cm",
              "short": "{0}/cm"
            },
            "short": {
              "other": "{0} cm"
            }
          },
          "day": {
            "long": {
              "other": "{0} d"
            },
            "narrow": {
              "other": "{0} d"
            },
            "perUnit": {
              "long": "{0}/d",
              "narrow": "{0}/d",
              "short": "{0}/d"
            },
            "short": {
              "other": "{0} d"
            }
          },
          "degree": {
            "long": {
              "other": "{0}°"
            },
            "narrow": {
              "other": "{0}°"
            },
            "perUnit": {},
            "short": {
              "other": "{0}°"
            }
          },
          "fahrenheit": {
            "long": {
              "other": "{0}°F"
            },
            "narrow": {
              "other": "{0}°F"
            },
            "perUnit": {},
            "short": {
              "other": "{0}°F"
            }
          },
          "fluid-ounce": {
            "long": {
              "other": "{0} fl oz US"
            },
            "narrow": {
              "other": "{0} fl oz US"
            },
            "perUnit": {},
            "short": {
              "other": "{0} fl oz US"
            }
          },
          "foot": {
            "long": {
              "other": "{0} ft"
            },
            "narrow": {
              "other": "{0} ft"
            },
            "perUnit": {
              "long": "{0}/ft",
              "narrow": "{0}/ft",
              "short": "{0}/ft"
            },
            "short": {
              "other": "{0} ft"
            }
          },
          "gallon": {
            "long": {
              "other": "{0} gal US"
            },
            "narrow": {
              "other": "{0} gal US"
            },
            "perUnit": {
              "long": "{0}/gal US",
              "narrow": "{0}/gal US",
              "short": "{0}/gal US"
            },
            "short": {
              "other": "{0} gal US"
            }
          },
          "gigabit": {
            "long": {
              "other": "{0} Gb"
            },
            "narrow": {
              "other": "{0} Gb"
            },
            "perUnit": {},
            "short": {
              "other": "{0} Gb"
            }
          },
          "gigabyte": {
            "long": {
              "other": "{0} GB"
            },
            "narrow": {
              "other": "{0} GB"
            },
            "perUnit": {},
            "short": {
              "other": "{0} GB"
            }
          },
          "gram": {
            "long": {
              "other": "{0} g"
            },
            "narrow": {
              "other": "{0} g"
            },
            "perUnit": {
              "long": "{0}/g",
              "narrow": "{0}/g",
              "short": "{0}/g"
            },
            "short": {
              "other": "{0} g"
            }
          },
          "hectare": {
            "long": {
              "other": "{0} ha"
            },
            "narrow": {
              "other": "{0} ha"
            },
            "perUnit": {},
            "short": {
              "other": "{0} ha"
            }
          },
          "hour": {
            "long": {
              "other": "{0} h"
            },
            "narrow": {
              "other": "{0} h"
            },
            "perUnit": {
              "long": "{0}/h",
              "narrow": "{0}/h",
              "short": "{0}/h"
            },
            "short": {
              "other": "{0} h"
            }
          },
          "inch": {
            "long": {
              "other": "{0} in"
            },
            "narrow": {
              "other": "{0} in"
            },
            "perUnit": {
              "long": "{0}/in",
              "narrow": "{0}/in",
              "short": "{0}/in"
            },
            "short": {
              "other": "{0} in"
            }
          },
          "kilobit": {
            "long": {
              "other": "{0} kb"
            },
            "narrow": {
              "other": "{0} kb"
            },
            "perUnit": {},
            "short": {
              "other": "{0} kb"
            }
          },
          "kilobyte": {
            "long": {
              "other": "{0} kB"
            },
            "narrow": {
              "other": "{0} kB"
            },
            "perUnit": {},
            "short": {
              "other": "{0} kB"
            }
          },
          "kilogram": {
            "long": {
              "other": "{0} kg"
            },
            "narrow": {
              "other": "{0} kg"
            },
            "perUnit": {
              "long": "{0}/kg",
              "narrow": "{0}/kg",
              "short": "{0}/kg"
            },
            "short": {
              "other": "{0} kg"
            }
          },
          "kilometer": {
            "long": {
              "other": "{0} km"
            },
            "narrow": {
              "other": "{0} km"
            },
            "perUnit": {
              "long": "{0}/km",
              "narrow": "{0}/km",
              "short": "{0}/km"
            },
            "short": {
              "other": "{0} km"
            }
          },
          "kilometer-per-hour": {
            "long": {
              "other": "{0} km/h"
            },
            "narrow": {
              "other": "{0} km/h"
            },
            "perUnit": {},
            "short": {
              "other": "{0} km/h"
            }
          },
          "liter": {
            "long": {
              "other": "{0} l"
            },
            "narrow": {
              "other": "{0} l"
            },
            "perUnit": {
              "long": "{0}/l",
              "narrow": "{0}/l",
              "short": "{0}/l"
            },
            "short": {
              "other": "{0} l"
            }
          },
          "liter-per-kilometer": {
            "long": {
              "other": "{0} L/km"
            },
            "narrow": {
              "other": "{0} L/km"
            },
            "perUnit": {},
            "short": {
              "other": "{0} L/km"
            }
          },
          "megabit": {
            "long": {
              "other": "{0} Mb"
            },
            "narrow": {
              "other": "{0} Mb"
            },
            "perUnit": {},
            "short": {
              "other": "{0} Mb"
            }
          },
          "megabyte": {
            "long": {
              "other": "{0} MB"
            },
            "narrow": {
              "other": "{0} MB"
            },
            "perUnit": {},
            "short": {
              "other": "{0} MB"
            }
          },
          "meter": {
            "long": {
              "other": "{0} m"
            },
            "narrow": {
              "other": "{0} m"
            },
            "perUnit": {
              "long": "{0}/m",
              "narrow": "{0}/m",
              "short": "{0}/m"
            },
            "short": {
              "other": "{0} m"
            }
          },
          "meter-per-second": {
            "long": {
              "other": "{0} m/s"
            },
            "narrow": {
              "other": "{0} m/s"
            },
            "perUnit": {},
            "short": {
              "other": "{0} m/s"
            }
          },
          "mile": {
            "long": {
              "other": "{0} mi"
            },
            "narrow": {
              "other": "{0} mi"
            },
            "perUnit": {},
            "short": {
              "other": "{0} mi"
            }
          },
          "mile-per-gallon": {
            "long": {
              "other": "{0} mpg US"
            },
            "narrow": {
              "other": "{0} mpg US"
            },
            "perUnit": {},
            "short": {
              "other": "{0} mpg US"
            }
          },
          "mile-per-hour": {
            "long": {
              "other": "{0} mi/h"
            },
            "narrow": {
              "other": "{0} mi/h"
            },
            "perUnit": {},
            "short": {
              "other": "{0} mi/h"
            }
          },
          "mile-scandinavian": {
            "long": {
              "other": "{0} smi"
            },
            "narrow": {
              "other": "{0} smi"
            },
            "perUnit": {},
            "short": {
              "other": "{0} smi"
            }
          },
          "milliliter": {
            "long": {
              "other": "{0} mL"
            },
            "narrow": {
              "other": "{0} mL"
            },
            "perUnit": {},
            "short": {
              "other": "{0} mL"
            }
          },
          "millimeter": {
            "long": {
              "other": "{0} mm"
            },
            "narrow": {
              "other": "{0} mm"
            },
            "perUnit": {},
            "short": {
              "other": "{0} mm"
            }
          },
          "millisecond": {
            "long": {
              "other": "{0} ms"
            },
            "narrow": {
              "other": "{0} ms"
            },
            "perUnit": {},
            "short": {
              "other": "{0} ms"
            }
          },
          "minute": {
            "long": {
              "other": "{0} min"
            },
            "narrow": {
              "other": "{0} min"
            },
            "perUnit": {
              "long": "{0}/min",
              "narrow": "{0}/min",
              "short": "{0}/min"
            },
            "short": {
              "other": "{0} min"
            }
          },
          "month": {
            "long": {
              "other": "{0} m"
            },
            "narrow": {
              "other": "{0} m"
            },
            "perUnit": {
              "long": "{0}/m",
              "narrow": "{0}/m",
              "short": "{0}/m"
            },
            "short": {
              "other": "{0} m"
            }
          },
          "ounce": {
            "long": {
              "other": "{0} oz"
            },
            "narrow": {
              "other": "{0} oz"
            },
            "perUnit": {
              "long": "{0}/oz",
              "narrow": "{0}/oz",
              "short": "{0}/oz"
            },
            "short": {
              "other": "{0} oz"
            }
          },
          "percent": {
            "long": {
              "other": "{0}%"
            },
            "narrow": {
              "other": "{0}%"
            },
            "perUnit": {},
            "short": {
              "other": "{0}%"
            }
          },
          "petabyte": {
            "long": {
              "other": "{0} PB"
            },
            "narrow": {
              "other": "{0} PB"
            },
            "perUnit": {},
            "short": {
              "other": "{0} PB"
            }
          },
          "pound": {
            "long": {
              "other": "{0} lb"
            },
            "narrow": {
              "other": "{0} lb"
            },
            "perUnit": {
              "long": "{0}/lb",
              "narrow": "{0}/lb",
              "short": "{0}/lb"
            },
            "short": {
              "other": "{0} lb"
            }
          },
          "second": {
            "long": {
              "other": "{0} s"
            },
            "narrow": {
              "other": "{0} s"
            },
            "perUnit": {
              "long": "{0}/s",
              "narrow": "{0}/s",
              "short": "{0}/s"
            },
            "short": {
              "other": "{0} s"
            }
          },
          "stone": {
            "long": {
              "other": "{0} st"
            },
            "narrow": {
              "other": "{0} st"
            },
            "perUnit": {},
            "short": {
              "other": "{0} st"
            }
          },
          "terabit": {
            "long": {
              "other": "{0} Tb"
            },
            "narrow": {
              "other": "{0} Tb"
            },
            "perUnit": {},
            "short": {
              "other": "{0} Tb"
            }
          },
          "terabyte": {
            "long": {
              "other": "{0} TB"
            },
            "narrow": {
              "other": "{0} TB"
            },
            "perUnit": {},
            "short": {
              "other": "{0} TB"
            }
          },
          "week": {
            "long": {
              "other": "{0} w"
            },
            "narrow": {
              "other": "{0} w"
            },
            "perUnit": {
              "long": "{0}/w",
              "narrow": "{0}/w",
              "short": "{0}/w"
            },
            "short": {
              "other": "{0} w"
            }
          },
          "yard": {
            "long": {
              "other": "{0} yd"
            },
            "narrow": {
              "other": "{0} yd"
            },
            "perUnit": {},
            "short": {
              "other": "{0} yd"
            }
          },
          "year": {
            "long": {
              "other": "{0} y"
            },
            "narrow": {
              "other": "{0} y"
            },
            "perUnit": {
              "long": "{0}/y",
              "narrow": "{0}/y",
              "short": "{0}/y"
            },
            "short": {
              "other": "{0} y"
            }
          }
        }
      }
    },
    "locale": "twq"
  });
}